 <template lang="pug">
  .crud
    div(v-if="has_permission")
      modal-import(model="quotes" :title="$t('front.import_modal', {model: $t('strings.quotes')})")
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            .list-title-cont
              .title-c
                h2 {{ $t('strings.cancelled') }}
                stage-indicator(color="#FC7314")
              span {{ $t('strings.cancelled_description') }}
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w="6")
            vm-button(icon="eye-outline" @click="showquotes" ) {{ $t('strings.quotes') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
        vm-row(vm-w="12")
          vm-col.card(vm-sm=12)
            vm-table(multiple v-model="selected"  max-height="350px" :data="quotes")
              template(slot="header")
                .d-flex.justify-content-between
                  vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                  div
                    vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                      vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                        vm-button(type="default" icon="funnel-outline" size="small")

                        vm-dropdown-menu(class="filters")
                          .heading.d-flex.justify-content-between
                            h4 {{ $t('strings.filters') }}
                            vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Additional" v-model="filters.whereIn.additional")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in additional")
                          .filter.d-flex
                            vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                    vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('projects.'+ item)")
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
                vm-th(v-if="!$auth.check('Customer')") {{ $t('projects.upload_quotation_cano_date') }}
                vm-th
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    slot(v-if="column != 'status' && column != 'amount' && column != 'quotation_created_by' && column != 'quotation_approved' && column != 'additional' && column != 'customer'") {{data[indextr][column]}}
                    slot(v-if="column == 'amount'")  {{data[indextr][column] | currency }}
                    slot(v-if="column == 'quotation_created_by'") {{ data[indextr]['quotation_created']['name'] }}
                    slot(v-if="column == 'customer'") {{ data[indextr]['customer']['name'] }}
                    vm-icon(v-if="column == 'quotation_approved' && data[indextr]['quotation_approved'] == 0" type="flat" icon="clock-outline" color="rgba(var(--gray),1)")
                    vm-icon(v-if="column == 'quotation_approved' && data[indextr]['quotation_approved'] == 1" type="flat" icon="checkmark-circle-2-outline" color="rgb(23, 201, 100)")
                    slot(v-if="column == 'changes_orders'") {{ data[indextr]['additional'] == 1 ? 'SI' : 'NO' }}
                    vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                  vm-td(v-if="!$auth.check('Customer')")
                    slot {{data[indextr]['upload_quotation_cano_date']}}

            vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
            transition(name="enter")
              .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotes')

export default {
  name: 'Cancelled',
  components: {
    ModalImport: () => import('@/components/modals/ModalImport.vue')
  },
  data: () => ({
    newRecord: {},
    permissions: {},
    quote: {},
    currentPage: 1,
    isModalAdditional: true,
    isModalQuote: true,
    selected: [],
    has_permission: true,
    revisions_index_permission: true,
    status_store_permission: true,
    amount_update_permission: true,
    customer_comments_quotation: true,
    customer: true,
    columns: [
      'project_name',
      'customer',
      'amount',
      'currency_display',
      'location',
      'status',
      'quotation_start_date',
      'quotation_delivery_date',
      'quotation_created_by',
      'comments_quotation',
      'quotation_approved',
      'upload_quotation_date',
      'customer_comments_quotation',
      'changes_orders'
    ],
    columnsOrderBy: [
      'quotation_start_date'
    ],
    status: [
      {
        text: 'Pending',
        value: 1,
        color: 'secondary'
      },
      {
        text: 'On hold',
        value: 2,
        color: 'warning'
      },
      {
        text: 'Assigned',
        value: 3,
        color: 'success'
      },
      {
        text: 'No assigned',
        value: 4,
        color: 'danger'
      },
      {
        text: 'Canceled',
        value: 5,
        color: 'gray'
      }
    ],
    additional: [
      {
        text: 'NO',
        value: 0
      },
      {
        text: 'SI',
        value: 1
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        status: [],
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.checkPermissionView('quoteds.index')
    this.filtersClear = parseVuexObject(this.filters)
    if (this.$route.params.customerId) {
      await this.getQuoteCanceled(1, this.$route.params.customerId)
    } else {
      await this.getQuoteCanceled(1)
    }
    await this.loadQuotesCanceledCatalog()
  },
  methods: {
    ...mapActions([
      'loadQuotesCancelled',
      'loadCatalogCatalog',
      'loadQuotesCanceledCatalog',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.categories_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'categories.index') > -1
      this.quotation_files_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.store') > -1
      this.quotation_files_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.index') > -1
      this.project_details_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'project_details.index') > -1
      this.revisions_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'revisions.index') > -1
      this.status_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'status.store') > -1
      this.amount_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'amount.update') > -1
      this.customer_comments_quotation = this.$auth.user().view_permissions.findIndex(e => e.name === 'customer_comments_quotation.store') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    showquotes () {
      this.$router.push({ name: 'quotes' })
    },
    assigned (quote) {
      this.newRecord = { ...quote }
      this.newRecord.approve_shop_drawings_weeks = 0
      this.newRecord.structure_weeks = 0
      this.newRecord.joist_weeks = 0
      this.newRecord.detailing_weeks = 0
      this.setModalAssignedVisible(true)
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.quotes.findIndex(u => u.id === this.selected[0].id)
      this.editQuote(this.selected[0], idx)
    },
    addRevision (quote) {
      this.$router.push(`/revisions/${quote.id}`)
    },
    amount (quote, index) {
      quote.amount ? (this.newRecord = { ...quote }) : (this.newRecord = { currency: 1, id: quote.id })
      this.setModalAmountVisible(true)
    },
    editQuote (quote, index) {
      let id = quote.id
      this.$router.push({ name: 'AddDetails', params: { id, isAdd: true } })
    },
    editProject (record) {
      this.isModalAdditional = false
      this.isModalQuote = true
      this.quote = { ...record }
      this.setModalProjectVisible(true)
    },
    async deleteQuoteConfirm (quote) {
      let t = this
      this.auxDeleteQuote = () => {
        t.deleteQuote(quote).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quote'), attribute: this.$t(quote.id) }),
        accept: this.auxDeleteQuote
      })
    },
    async deleteQuotesConfirm () {
      let t = this
      let quotesMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteQuote = () => {
        t.deleteQuotes(quotesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quote'), attribute: quotesMany.values }),
        accept: this.auxDeleteQuote
      })
    },
    async setActionQuote (record, action) {
      record.id && this.actionQuote({ id: record.id, action })
    },
    async getQuoteCanceled (page, customerId) {
      this.loadQuotesCancelled({ page: page, customer: customerId })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalogCatalog({ filter: value, url: url })
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'quotes',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('quotes.' + column)}` : `${str} ${t.$t('quotes.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.quoted'), columns: concatColumns, column: this.$t('projects.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getQuoteCanceled(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getQuoteCanceled(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.list-title-cont {
  display: flex;
  flex-direction: column;
  .title-c {
    display: flex;
    align-items: center;
  }
}
</style>
